import $ from "jquery";

const $countrySelect = $("#KundeDaten_Country");
const $stateLabel = $("label[for='KundeDaten_State']");
const countriesWithStates = new Set(["us", "ca"]);
const initStateLabelText = $stateLabel.text();

if ($countrySelect.length) {
	updateStateLabelText();
}

$countrySelect.on("change", function() {
	updateStateLabelText();
});

function hasSelectedCountryStates(): boolean {
	let selectedCountry = $countrySelect.children(":selected").val() as string;
	return countriesWithStates.has(selectedCountry.toLowerCase());
}

function updateStateLabelText() {
	let stateLabelText = hasSelectedCountryStates() ? initStateLabelText : initStateLabelText.replace("*", "");
	$stateLabel.text(stateLabelText);
}
